import { createClient } from '@supabase/supabase-js';

// Credenciales de Supabase
const SUPABASE_URL = 'https://glfraukyowoccsrylqei.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdsZnJhdWt5b3dvY2NzcnlscWVpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ5Mzk5MDcsImV4cCI6MjA4MDUxNTkwN30.2r2gF8ABE248kvQPSU7WfIJnLT_kYiznDnvH6QjBqOk';

let supabaseInstance = null;

if (SUPABASE_URL && SUPABASE_ANON_KEY) {
  try {
    supabaseInstance = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true
      }
    });
  } catch (error) {
    console.error('Supabase client creation failed:', error);
  }
} else {
  console.error('CRITICAL: Supabase credentials missing.');
}

export const supabase = supabaseInstance;